import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { FaCheck } from 'react-icons/fa';
import { UploadedText, UploadIcon, DeleteBtn } from './styled';

const ButtonUpload = ({
  variant,
  disabled,
  isUploading,
  onUpload,
  onDelete,
  isUploaded,
  label,
  showButtonOnRemoving,
  successText,
  display,
  multiple,
  className,
  acceptedFiletypes
}) => {
  const inputReference = useRef();

  const fileUploadInputChange = (e) => {
    [...e.target.files].map((file) => onUpload(file));
    e.target.value = null;
  };

  const fileUploadAction = () => {
    inputReference.current.click();
  };

  if (display) {
    return (
      <UploadedText className={className} $display>
        {successText} <FaCheck />
      </UploadedText>
    );
  }

  if (isUploaded) {
    if (isUploading) {
      if (showButtonOnRemoving) {
        return (
          <Button variant={variant} className={className} disabled>
            Removing...
          </Button>
        );
      }

      return <UploadedText className={className}>Removing...</UploadedText>;
    }

    return (
      <UploadedText className={className}>
        <>
          {successText} <FaCheck /> <DeleteBtn onClick={onDelete} />{' '}
        </>
      </UploadedText>
    );
  }

  return (
    <>
      <Button
        variant={variant}
        onClick={fileUploadAction}
        className={className}
        disabled={disabled || isUploading}
      >
        {isUploading ? (
          'Uploading...'
        ) : (
          <>
            <UploadIcon /> {label}
          </>
        )}
      </Button>

      <input
        type="file"
        multiple={multiple}
        hidden
        ref={inputReference}
        onChange={fileUploadInputChange}
        accept={acceptedFiletypes}
      />
    </>
  );
};

ButtonUpload.propTypes = {
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  successText: PropTypes.string,
  isUploading: PropTypes.bool,
  isUploaded: PropTypes.bool,
  showButtonOnRemoving: PropTypes.bool,
  onUpload: PropTypes.func,
  onDelete: PropTypes.func,
  className: PropTypes.string,
  display: PropTypes.bool,
  multiple: PropTypes.bool,
  acceptedFiletypes: PropTypes.string
};

ButtonUpload.defaultProps = {
  label: 'Upload file',
  isUploading: false,
  display: false,
  disabled: false
};

export default ButtonUpload;
